import React, { useState } from 'react';
import { ToastProvider } from '../components/ui/Toast';
import { BirthdaysTodayWidget } from '../components/widgets/BirthdaysTodayWidget';
import { BirthdaysThisWeekWidget } from '../components/widgets/BirthdaysThisWeekWidget';
import { CandidatesStartingWidget } from '../components/widgets/CandidatesStartingWidget';
import { InterviewsWidget } from '../components/widgets/InterviewsWidget';
import { FollowUpsWidget } from '../components/widgets/FollowUpsWidget';
import { WaitingOnResponseWidget } from '../components/widgets/WaitingOnResponseWidget';
import { UpcomingScheduleWidget } from '../components/widgets/UpcomingScheduleWidget';
import { CandidateModal } from '../components/CandidateModal';
import { Logo } from '../components/Logo';
import { Candidate } from '../types/hr.types';
export function HRCommandCenter() {
  const [selectedCandidate, setSelectedCandidate] = useState<Candidate | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCandidateClick = (candidate: Candidate) => {
    setSelectedCandidate(candidate);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedCandidate(null), 300);
  };
  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const userName = 'Sarah';
  const SectionHeader = ({
    children
  }: {
    children: React.ReactNode;
  }) => <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wider flex items-center gap-2" data-id="element-1907">
      <div className="h-1 w-8 bg-gradient-to-r from-orange-500 to-orange-400 rounded-full" data-id="element-1908"></div>
      {children}
    </h2>;
  return <ToastProvider data-id="element-1909">
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-orange-50/30 to-gray-50 p-6 md:p-8 font-sans text-gray-900" data-id="element-1910">
        <div className="max-w-[1600px] mx-auto space-y-6" data-id="element-1911">
          <header className="relative overflow-hidden rounded-2xl bg-[#1B2B6B] p-8 md:p-10 shadow-xl shadow-[#1B2B6B]/30" data-id="element-1912">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(255,255,255,0.15)_0%,_transparent_60%)]" data-id="element-1913"></div>
            <div className="absolute bottom-0 right-0 w-1/2 h-1/2 bg-gradient-to-tl from-white/10 to-transparent" data-id="element-1914"></div>
            <div className="relative flex items-center justify-between gap-8" data-id="element-1915">
              <div className="flex items-center gap-8" data-id="element-1916">
                <div className="flex-shrink-0 bg-white px-3 py-2 rounded-xl shadow-sm" data-id="element-1917">
                  <Logo className="h-10 md:h-12 w-auto" data-id="element-1918" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-1919">
                  <h1 className="text-2xl md:text-3xl font-bold text-white tracking-tight drop-shadow-sm" data-id="element-1920">
                    HR Command Center
                  </h1>
                  <p className="text-orange-100 mt-1 text-sm md:text-base" data-id="element-1921">
                    Welcome back, {userName}! Here's what's happening today.
                  </p>
                </div>
              </div>
              <div className="hidden md:block text-right" data-id="element-1922">
                <div className="text-white/90 text-sm font-medium whitespace-nowrap" data-id="element-1923">
                  {formattedDate}
                </div>
              </div>
            </div>
          </header>

          {/* Balanced 3-column layout. Each column is a flex stack; the last
           widget in each column expands (flex-1) so columns end at the same
           height — no empty space below short widgets. */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch" data-id="element-1924">
            <div className="flex flex-col gap-4 min-h-0" data-id="element-1925">
              <SectionHeader data-id="element-1926">Action Required</SectionHeader>
              <FollowUpsWidget type="overdue" onCandidateClick={handleCandidateClick} data-id="element-1927" />
              <FollowUpsWidget type="today" onCandidateClick={handleCandidateClick} data-id="element-1928" />
              <div className="flex-1 min-h-[200px]" data-id="element-1929">
                <WaitingOnResponseWidget onCandidateClick={handleCandidateClick} data-id="element-1930" />
              </div>
            </div>

            <div className="flex flex-col gap-4 min-h-0" data-id="element-1931">
              <SectionHeader data-id="element-1932">Today & This Week</SectionHeader>
              <InterviewsWidget type="in-person" period="today" data-id="element-1933" />
              <InterviewsWidget type="phone" period="today" data-id="element-1934" />
              <div className="flex-1 min-h-[200px]" data-id="element-1935">
                <CandidatesStartingWidget period="week" onCandidateClick={handleCandidateClick} data-id="element-1936" />
              </div>
              <BirthdaysTodayWidget data-id="element-1937" />
              <BirthdaysThisWeekWidget data-id="element-1938" />
            </div>

            <div className="flex flex-col gap-4 min-h-0" data-id="element-1939">
              <SectionHeader data-id="element-1940">Upcoming Schedule</SectionHeader>
              <div className="flex-1 min-h-[600px]" data-id="element-1941">
                <UpcomingScheduleWidget onCandidateClick={handleCandidateClick} data-id="element-1942" />
              </div>
            </div>
          </div>
        </div>
        <CandidateModal candidate={selectedCandidate} isOpen={isModalOpen} onClose={handleCloseModal} data-id="element-1943" />
      </div>
    </ToastProvider>;
}